import { assign } from 'lodash';

var _darkPaletteCache = {
  colors: [],
  hex: []
};

var getPalette = function (colorCount, paletteConfig, paletteCache) {
  colorCount = colorCount || 5;

  if (paletteCache.hex.length >= colorCount) {
    return paletteCache.hex.slice(0, colorCount)
  }

  paletteCache.colors = distinctColors(
    assign({count: colorCount}, paletteConfig)
  );

  paletteCache.hex = paletteCache.colors.map((color) => (color.hex()));

  return paletteCache.hex;
};

exports.getDarkPalette = function (colorCount) {
  return getPalette(colorCount, {
    lightMin: 45,
    lightMax: 70
  }, _darkPaletteCache);
};
